import { defineMessages } from 'react-intl';

const messages = defineMessages({
  requestsNoResults: {
    id: 'repvisits.notifications.requests.requestsNoResults',
    defaultMessage: 'You currently have no notifications',
  },
  requestsYourVisitRequest: {
    id: 'repvisits.notifications.requests.requestsYourVisitRequest',
    defaultMessage: 'Your Rep Visit request was',
  },
  requestsYourVisitRequestPart1: {
    id: 'repvisits.notifications.requests.requestsYourVisitRequestPart1',
    defaultMessage: 'Your ',
  },
  requestsYourVisitRequestPart2: {
    id: 'repvisits.notifications.requests.requestsYourVisitRequestPart2',
    defaultMessage: ' Visit request was',
  },
  requestsWaitingForConfirmation: {
    id: 'repvisits.notifications.requests.requestsWaitingForConfirmation',
    defaultMessage: 'WAITING FOR CONFIRMATION',
  },
  requestsYourCFRequest: {
    id: 'repvisits.notifications.requests.requestsYourCFRequest',
    defaultMessage: 'Your College Fair request was',
  },
  requestsSent: {
    id: 'repvisits.notifications.requests.requestsSent',
    defaultMessage: 'sent',
  },
  requestsViewFullDetails: {
    id: 'repvisits.notifications.requests.requestsViewFullDetails',
    defaultMessage: 'View Full Details',
  },
});

export default messages;
